import axios from 'axios';

const apiBaseUrl =
  process.env.REACT_APP_API_URL ||
  'http://localhost:5001/api';

const instance = axios.create({
  baseURL: apiBaseUrl.replace(/\/$/, ''),
  // baseURL: 'https://tabullet.com/api',

  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/auth';
    }
    return Promise.reject(error);
  }
);

export default instance; 
